module.exports = __webpack_public_path__ + "media/2.c29ac40b.mp3";